import { render, staticRenderFns } from "./VehicleInner.vue?vue&type=template&id=fa87cae0&scoped=true"
import script from "./VehicleInner.vue?vue&type=script&lang=js"
export * from "./VehicleInner.vue?vue&type=script&lang=js"
import style0 from "./VehicleInner.vue?vue&type=style&index=0&id=fa87cae0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa87cae0",
  null
  
)

export default component.exports